export const securityConfig = {
  // Temporary launch setting. Set to true only after Turnstile is verified end to end.
  turnstileEnabled: false,
} as const;
